import Navbar from "../components/Navbar2";
import Enterapp from '../components/Enterapp'
const AppPage = () => {
    return (  
        <>
        <div className="AppPage">
        <Navbar/>
        <Enterapp/>
        </div>
        </>
    );
}
 
export default AppPage;